export default __webpack_public_path__ + "static/media/0.6mm 1.84580272.jpg";